import { Text, View } from "@react-pdf/renderer";
import { styles } from "../styles";

export function IntroView({ relatorio, sharedOptions }) {
  return (
    <View style={styles.stylesReportIntro.viewer}>
      <Text
        style={styles.stylesReportIntro.clientTitle}
      >{`Cliente : ${relatorio?.client?.toUpperCase()}`}</Text>
      <View style={styles.stylesReportIntro.columnView2}>
        <Text style={[styles.text, { textIndent: "20px" }]}>
          {`Resultados de tráfego relacionados ao cliente ${relatorio?.client}. As métricas utilizadas para os cálculos dos valores apresentados são: tráfego total, ${relatorio?.percentil}th (percentil). As coletas do valores apresentados neste relatório correspondem ao período entre ${sharedOptions?.dataInicial} ${sharedOptions?.horaInicial} à ${sharedOptions?.dataFinal} ${sharedOptions?.horaFinal}.`}
        </Text>
      </View>
    </View>
  );
}
